export interface GridInfoGeneral {
  id?: number;
  timezone: string;
  name: string;
  dotNumber: string;
  mcNumber: string;
  street: string;
  city: string;
  country: string;
  state: string;
  zip: string;
  phone: string;
  contactPhone: string;
  email: string;
}

export interface GridInfoSettings {
  exemptDriver: boolean;
  hosRules: string;
  cargoType: string;
  restart: string;
  restBreak: string;
  shortHaulException: boolean;
  allowPersonalUse: boolean;
  allowYardMoves: boolean;
}

export interface GridInfoTerminal {
  terminals: GridInfoTerminalItem[];
}

export interface GridInfoTerminalItem {
  id?: number;
  timezone: string;
  street: string;
  city: string;
  country: string;
  state: string;
  zip: string;
}

export interface GridInfo extends GridInfoGeneral, GridInfoSettings, GridInfoTerminal {}


export const GridInfoModelGeneral = (): GridInfoGeneral => {
  return {
    id: 0,
    timezone: '',
    name: '',
    dotNumber: '',
    mcNumber: '',
    street: '',
    city: '',
    country: '',
    state: '',
    zip: '',
    phone: '',
    contactPhone: '',
    email: ''
  };
};

export const GridInfoModelSettings = (): GridInfoSettings => {
  return {
    exemptDriver: false,
    hosRules: '',
    cargoType: '',
    restart: '',
    restBreak: '',
    shortHaulException: false,
    allowPersonalUse: false,
    allowYardMoves: false,
  };
};

export const GridInfoModelTerminal = (): GridInfoTerminal => {
  return {
    terminals: [],
  };
};

export const GridInfoModelTerminalItem = (): GridInfoTerminalItem => {
  return {
    id: 0,
    timezone: '',
    street: '',
    city: '',
    country: '',
    state: '',
    zip: '',
  };
};

export const GridInfoModel = (): GridInfo => {
  return {
    ...GridInfoModelGeneral(),
    ...GridInfoModelSettings(),
    ...GridInfoModelTerminal(),
    ...GridInfoModelGeneral(),
  };
};